module.exports = __webpack_public_path__ + "static/media/12.de009f74.jpeg";